import { render, staticRenderFns } from "./house-group.vue?vue&type=template&id=7072a3e4&scoped=true"
import script from "./house-group.vue?vue&type=script&lang=js"
export * from "./house-group.vue?vue&type=script&lang=js"
import style0 from "./house-group.vue?vue&type=style&index=0&id=7072a3e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7072a3e4",
  null
  
)

export default component.exports